import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { AdminsRoutingModule } from './admins.routing';
import { ReactiveFormsModule } from '@angular/forms';
import { FormErrorsDirectiveModule } from '@rappi/common';
import { InputModule } from '@rappi/ui/input';
import { FormGroupModule } from '../../components/form-group/form-group.module';
import { CardModule } from '@rappi/ui/card';
import { DynamicTableModule } from '@rappi/ui/dynamic-table';
import { ActionsModule } from '../../components/actions/actions.module';
import { ViewFormFieldModule } from '../../components/view-form-field/view-form-field.module';

import { TableComponent } from './components/table/table.component';
import { ManagerComponent } from './components/manager/manager.component';
import { ViewComponent } from './components/view/view.component';

@NgModule({
  declarations: [TableComponent, ManagerComponent, ViewComponent],
  imports: [
    CommonModule,
    AdminsRoutingModule,
    ReactiveFormsModule,
    FormErrorsDirectiveModule,
    InputModule,
    FormGroupModule,
    CardModule,
    DynamicTableModule,
    ActionsModule,
    ViewFormFieldModule
  ]
})
export class AdminsModule {}
